var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combine } from 'zustand/middleware';
export function serviceBaseActions(initialValues) {
    return combine(initialValues, function (setState, getState) { return ({
        getInitialized: function () {
            var state = getState();
            return state.initialized;
        },
        setPageContent: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { loading: false, initialized: true, content: value })); });
        },
        setError: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { loading: false, initialized: true, error: value })); });
        },
        setInitialized: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { initialized: value })); });
        },
        setLoading: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { loading: value })); });
        },
        resetState: function () {
            setState(function () { return initialValues; });
        },
    }); });
}
